import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class InvoiceExpensesClassificationCategory  {
    _originalTypeClassName = "zERP.BO.InvoiceExpensesClassificationCategory";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
InvoiceExpensesClassificationCategory.translate = translateService;
}
this.Types = [];
this.Id = null;
this.IsDefault = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
IsDefault:any;
Category:any;
Types:any;
static setCategory = ($this, value) => {
var oldValue = $this.Category;
$this.Category = value;
if (value != null) {
}
}
static setTypes = ($this, items) => {
                if (items == null) items = [];
                if ($this.Types == null) $this.Types = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Types.length > 0) {
                    Domain.InvoiceExpensesClassificationCategory.removeTypes($this, $this.Types[0]);
                }

                Domain.InvoiceExpensesClassificationCategory.addManyTypes($this, copyItems);
            }
static addManyTypes = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.InvoiceExpensesClassificationCategory.addTypes($this, items[i]);
                }
            }
static addTypes = ($this, item) => {
                if ($this.Types == null) $this.Types = [];
                if (item == null || $this.Types.indexOf(item) > -1) return;
                $this.Types.push(item);
}
static addRangeTypes = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.InvoiceExpensesClassificationCategory.addTypes($this, item));
            }
static removeTypes = ($this, item) => {
                if ($this == null || $this.Types == null || $this.Types.indexOf(item) === -1) return;
                var _index = $this.Types.indexOf(item);
                $this.Types.splice(_index, 1);
}
static clearTypes = ($this) => { $this.Types = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}